export const PAGE_SET = 'order.PAGE_SET';

export const PICKUP_ADDRESS_SELECTED = 'order.PICKUP_ADDRESS_SELECTED';
export const PICKUP_COORDINATES_SELECTED = 'order.PICKUP_COORDINATES_SELECTED';
export const PICKUP_DATE_SELECTED = 'order.PICKUP_DATE_SELECTED';
export const PICKUP_TIME_SELECTED = 'order.PICKUP_TIME_SELECTED';

export const DROPOFF_ADDRESS_SELECTED = 'order.DROPOFF_ADDRESS_SELECTED';
export const DROPOFF_COORDINATES_SELECTED = 'order.DROPOFF_COORDINATES_SELECTED';
export const DROPOFF_DATE_SELECTED = 'order.DROPOFF_DATE_SELECTED';
export const DROPOFF_TIME_SELECTED = 'order.DROPOFF_TIME_SELECTED';
export const DROPOFF_INSTRUCTIONS_SELECTED = 'order.DROPOFF_INSTRUCTIONS_SELECTED';

export const BAGS_COUNT_SET = 'order.BAGS_COUNT_SET';
export const BAGS_I_TITLE_SET = 'order.BAGS_I_TITLE_SET';
export const BAGS_I_DESC_SET = 'order.BAGS_I_DESC_SET';

export const ERROR_TEXT = 'order.ERROR_TEXT';

export const COUPON_CODE_SET = 'order.COUPON_CODE_SET';
export const PROMOCODE_STATUS_SET = 'order.PROMOCODE_STATUS_SET';
export const PRICE_BLOCK_VISIBILITY_SET = 'order.PRICE_BLOCK_VISIBILITY_SET';
export const PRICE_SET = 'order.PRICE_SET';
export const REFERRAL_CODE_SET = 'order.REFERRAL_CODE_SET';

export const BOTTOM_SET = 'order.BOTTOM_SET';
export const LOADING_SET = 'order.LOADING_SET';

export const PICKUP_AIRPORT_SET = 'order.PICKUP_AIRPORT_SET';
export const PICKUP_AIRPORT_TERMINAL_SET = 'order.PICKUP_AIRPORT_TERMINAL_SET';
export const DROPOFF_AIRPORT_SET = 'order.DROPOFF_AIRPORT_SET';
export const DROPOFF_AIRPORT_TERMINAL_SET = 'order.DROPOFF_AIRPORT_TERMINAL_SET';

export const INSURANCE_SET = 'order.INSURANCE_SET';

export const ERROR_FIELD_SET = 'order.ERROR_FIELD_SET';

export const REFERRAL_LOGO_SET = 'order.REFERRAL_LOGO_SET';